module.exports = __webpack_public_path__ + "img/glas_3.c86f2185.png";